/**
 * Wishlist button feature for customers
 */

if (!customElements.get("wishlist-button")) {
  customElements.define(
    "wishlist-button",

    class WishlistButton extends HTMLElement {
      static observedAttributes = ["is-wishlisted"];

      constructor() {
        super();
        this.productHandle = "";
        this.wishlistStore = {
          /**
           * @type Array<{productHandle: string, variant?:string}>
           */
          items: [],
        };
        this.productHasVariants = false;
        this.currentVariant = undefined;
      }

      connectedCallback() {
        /* first, check wishlisted items */
        const _wishlistString = localStorage.getItem("xtra__wishlist");

        try {
          const _wishlistData = JSON.parse(_wishlistString);
          if (Array.isArray(_wishlistData.items)) {
            // wishlistStore initialised, can compare
            this.wishlistStore = _wishlistData;
          }
        } catch (err) {
          // error parsing JSON, just reset the store;
          this.wishlistStore.items = [];
          this.saveWishlistStoreToLocalStorage();
        }

        /* get product handle */
        const a = document.querySelector("[data-product-handle]");
        if (a === null) {
          // does not have any element with product handle, abort
          return;
        }
        this.productHandle = a.getAttribute("data-product-handle");

        /* listen to variant selection */
        const variantOptionsElem = document.querySelector("variant-options");

        if (variantOptionsElem) {
          const initialVariant = variantOptionsElem.currentVariant.id;
          this.currentVariant = initialVariant;
          this.productHasVariants = true;

          variantOptionsElem.addEventListener(
            "variantChangeEnd",
            function (e) {
              this.currentVariant = e.target.currentVariant.id;
              this.updateButtonState();
            }.bind(this),
          );
        }

        this.addEventListener("click", this.handleClick);
        this.updateButtonState();
      }

      saveWishlistStoreToLocalStorage() {
        localStorage.setItem(
          "xtra__wishlist",
          JSON.stringify(this.wishlistStore),
        );
      }

      updateButtonState() {
        if (!Array.isArray(this.wishlistStore.items)) {
          return;
        }

        const matchingItem = this.wishlistStore.items.find((item) => {
          if (item.productHandle === this.productHandle) {
            if (this.productHasVariants) {
              return item.variant === this.currentVariant;
            } else {
              return true;
            }
          }
        });

        if (matchingItem === undefined) {
          // no item with matching product handle, safe to assume not wishlisted
          this.removeAttribute("data-wishlisted");
        } else {
          if (!this.productHasVariants) {
            // non variants product, safe to assume this is wishlisted
            this.setAttribute("data-wishlisted", "true");
          } else {
            // has variants, check variants too
            if (matchingItem.variant === this.currentVariant) {
              this.setAttribute("data-wishlisted", "true");
            } else {
              this.removeAttribute("data-wishlisted");
            }
          }
        }
      }

      handleClick() {
        if (this.getAttribute("data-wishlisted") !== null) {
          // remove item in wishlistStore

          const removeIdx = this.wishlistStore.items.findIndex(
            function (wi) {
              if (wi.productHandle === this.productHandle) {
                if (this.productHasVariants) {
                  return wi.variant === this.currentVariant;
                } else {
                  return true;
                }
              }
            }.bind(this),
          );

          if (removeIdx > -1) {
            this.wishlistStore.items.splice(removeIdx, 1);
            vanillaToast.show("Removed from wishlist", { immediately: true });
          }
        } else {
          this.wishlistStore.items.push(
            this.productHasVariants
              ? {
                  productHandle: this.productHandle,
                  variant: this.currentVariant,
                }
              : {
                  productHandle: this.productHandle,
                },
          );

          vanillaToast.show("Added to wishlist", { immediately: true });
        }

        this.saveWishlistStoreToLocalStorage();
        this.updateButtonState();
      }
    },
  );
}
